function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSimHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 288.833 158.136 L 275.637 158.136 C 274.236 158.134 273.101 156.998 273.099 155.597 L 273.099 142.401 C 273.101 141.001 274.236 139.865 275.637 139.864 L 288.833 139.864 C 290.234 139.865 291.369 141.001 291.37 142.401 L 291.37 155.597 C 291.369 156.998 290.234 158.134 288.833 158.136 Z M 275.637 140.879 C 274.796 140.88 274.115 141.561 274.115 142.401 L 274.115 155.597 C 274.115 156.438 274.796 157.12 275.637 157.121 L 288.833 157.121 C 289.674 157.12 290.354 156.438 290.355 155.597 L 290.355 142.401 C 290.354 141.561 289.674 140.88 288.833 140.879 Z",
    fill: "#e6e6e6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135.048 79.467 L 121.852 79.467 C 120.452 79.465 119.317 78.33 119.315 76.93 L 119.315 63.734 C 119.317 62.333 120.452 61.197 121.852 61.196 L 135.048 61.196 C 136.449 61.197 137.585 62.333 137.587 63.734 L 137.587 76.93 C 137.585 78.33 136.449 79.465 135.048 79.467 Z M 121.852 62.21 C 121.012 62.211 120.331 62.893 120.33 63.734 L 120.33 76.93 C 120.331 77.769 121.012 78.451 121.852 78.452 L 135.048 78.452 C 135.889 78.451 136.571 77.769 136.572 76.93 L 136.572 63.734 C 136.571 62.893 135.889 62.211 135.048 62.21 Z",
    fill: "#e6e6e6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280.712 151.537 L 267.516 151.537 C 266.115 151.536 264.98 150.401 264.978 149 L 264.978 135.804 C 264.98 134.403 266.115 133.268 267.516 133.266 L 280.712 133.266 C 282.113 133.268 283.248 134.403 283.25 135.804 L 283.25 149 C 283.248 150.401 282.113 151.536 280.712 151.537 Z M 267.516 134.281 C 266.675 134.282 265.995 134.963 265.994 135.804 L 265.994 149 C 265.995 149.841 266.675 150.521 267.516 150.522 L 280.712 150.522 C 281.553 150.521 282.234 149.841 282.234 149 L 282.234 135.804 C 282.234 134.963 281.553 134.282 280.712 134.281 Z",
    fill: "#e6e6e6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.305 261.673 L 38.109 261.673 C 36.708 261.671 35.573 260.537 35.571 259.136 L 35.571 245.94 C 35.573 244.539 36.708 243.404 38.109 243.402 L 51.305 243.402 C 52.705 243.404 53.841 244.539 53.843 245.94 L 53.843 259.136 C 53.841 260.537 52.705 261.671 51.305 261.673 Z M 38.109 244.417 C 37.269 244.418 36.587 245.099 36.586 245.94 L 36.586 259.136 C 36.587 259.976 37.269 260.657 38.109 260.658 L 51.305 260.658 C 52.145 260.657 52.827 259.976 52.828 259.136 L 52.828 245.94 C 52.827 245.099 52.145 244.418 51.305 244.417 Z",
    fill: "#e6e6e6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43.185 255.075 L 29.989 255.075 C 28.588 255.074 27.452 253.938 27.451 252.537 L 27.451 239.341 C 27.452 237.941 28.588 236.805 29.989 236.804 L 43.185 236.804 C 44.585 236.805 45.72 237.941 45.722 239.341 L 45.722 252.537 C 45.72 253.938 44.585 255.074 43.185 255.075 Z M 29.989 237.819 C 29.148 237.82 28.466 238.501 28.465 239.341 L 28.465 252.537 C 28.466 253.378 29.148 254.059 29.989 254.06 L 43.185 254.06 C 44.024 254.059 44.706 253.378 44.707 252.537 L 44.707 239.341 C 44.706 238.501 44.024 237.82 43.185 237.819 Z",
    fill: "#e6e6e6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.362 104.864 L 196.484 104.864 C 208.621 104.864 219.139 113.274 221.808 125.115 L 283.515 398.813 C 286.38 411.522 277.091 423.743 264.078 424.384 L 138.537 430.57 C 124.631 431.255 112.375 421.518 109.896 407.818 L 74.893 214.31 L 72.289 215.054 L 65.591 178.377 L 68.272 177.707 L 58.502 123.691 C 56.717 113.831 64.342 104.781 74.362 104.864 Z",
    fill: "#3f3d56",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.407 110.763 L 194.661 110.763 C 203.097 110.763 210.392 116.639 212.19 124.88 L 271.419 396.345 C 272.868 402.988 268.069 409.364 261.285 409.809 L 136.149 418.01 C 128.84 418.489 122.337 413.404 121.039 406.196 L 70.498 125.61 C 69.105 117.875 75.05 110.763 82.909 110.763 L 96.432 110.763 C 99.122 110.763 101.479 112.569 102.179 115.168 L 102.179 115.168 C 102.796 117.462 104.877 119.056 107.252 119.056 L 171.452 119.056 C 176.145 119.056 180.047 115.443 180.407 110.763 Z",
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.235 156.921 215.989 156.921 230.451 222.085 92.923 224.623 80.235 156.921",
    fill: "#1f306d",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.149 280.328 241.11 280.328 242.125 286.445 210.164 286.445 209.149 280.328",
    style: {
      fill: "rgb(229, 26, 148)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.123,
    y: 228.942,
    width: 135.576,
    height: 0.638,
    transform: "matrix(0.999776, -0.021172, 0.021172, 0.999776, -59.327423, 26.357431)",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.714,
    y: 247.918,
    width: 138.133,
    height: 0.638,
    transform: "matrix(0.999733, -0.023088, 0.023088, 0.999733, -60.194824, 26.863853)",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.345 345.799 254.306 345.799 255.321 351.918 223.36 351.918 222.345 345.799",
    style: {
      fill: "rgb(229, 26, 148)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.319,
    y: 294.415,
    width: 135.576,
    height: 0.638,
    transform: "matrix(0.999776, -0.021172, 0.021172, 0.999776, -60.710632, 26.651497)",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.91,
    y: 313.391,
    width: 138.133,
    height: 0.638,
    transform: "matrix(0.999733, -0.023088, 0.023088, 0.999733, -61.702972, 27.18597)",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.87 432.311 333.823 432.31 330.947 408.986 339.872 408.986 339.87 432.311",
    fill: "#a0616a",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341.413 438.173 L 321.914 438.172 L 321.914 437.926 C 321.915 433.734 325.312 430.337 329.504 430.336 L 329.504 430.336 L 341.413 430.337 Z",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.994 428.352 409.109 429.737 400.961 407.693 409.648 405.647 414.994 428.352",
    fill: "#a0616a",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 417.84 433.704 L 398.86 438.173 L 398.804 437.933 C 397.842 433.853 400.371 429.767 404.451 428.805 L 404.451 428.805 L 416.044 426.076 Z",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 338.635 333.929 C 338.646 332.714 339.007 304.028 346.87 293.181 L 346.986 293.021 L 374.389 296.801 L 373.777 302.823 C 374.982 303.995 384.462 313.901 387.2 337.362 L 416.286 415.48 L 402.764 416.709 L 362.737 331.434 L 341.555 424.128 L 328.15 424.128 Z",
    style: {
      fill: "rgb(229, 26, 148)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 343.659 294.239 L 346.338 280.177 C 345.814 279.501 343.49 276.26 344.008 272.46 C 344.345 269.981 345.825 267.807 348.407 265.997 L 355.35 249.797 L 355.444 249.741 C 355.911 249.466 366.966 243.074 372.993 249.104 C 373.143 249.221 387.982 261 382.023 276.89 L 374.667 298.961 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 334.34 313.265 C 337.416 312.913 339.426 309.867 338.54 306.901 L 352.879 296.57 L 344.295 293.306 L 331.995 303.616 C 328.388 304.96 327.588 309.703 330.555 312.156 C 331.611 313.029 332.98 313.43 334.34 313.265 Z",
    fill: "#a0616a",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.975 296.554 L 358.865 279.307 L 352.358 257.073 C 351.738 254.944 352.029 252.654 353.164 250.75 C 354.214 248.954 355.973 247.685 358.009 247.253 C 361.756 246.46 365.158 248.558 368.118 253.491 L 368.14 253.534 C 368.63 254.732 380.034 282.922 371.326 288.95 C 362.809 294.847 343.057 303.431 342.858 303.518 L 342.626 303.618 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.069,
    cy: 229.981,
    r: 13.26,
    fill: "#a0616a",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.858,
    cy: 213.515,
    r: 11.732,
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.977 223.229 C 390.428 227.962 381.167 224.813 378.861 217.07 C 379.987 226.03 390.392 230.411 397.589 224.954 C 401.484 222.002 403.14 216.944 401.745 212.259 C 402.281 216.512 400.452 220.719 396.977 223.229 Z",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 350.679 223.243 C 352.728 219.575 353.511 218.044 356.152 215.814 C 358.487 213.843 361.36 213.264 363.676 215.132 C 373.481 210.896 384.194 218.862 382.96 229.471 C 381.727 240.08 369.471 245.375 360.9 239.003 C 357.38 236.384 355.304 232.255 355.304 227.868 C 355.307 227.343 355.338 226.82 355.399 226.299 C 353.385 226.016 352.693 223.525 350.679 223.243 Z",
    fill: "#2f2e41",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 472.04 438.804 L 278.668 438.804 C 278.278 438.804 278.033 438.381 278.229 438.043 C 278.319 437.886 278.487 437.789 278.668 437.789 L 472.04 437.789 C 472.431 437.789 472.675 438.212 472.479 438.55 C 472.389 438.707 472.221 438.804 472.04 438.804 Z",
    fill: "#3f3d56",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSimHero);
export default __webpack_public_path__ + "static/media/mobileSimHero.61bfced1d8dd9acb229c9fe687922cd4.svg";
export { ForwardRef as ReactComponent };